// @flow
import * as React from 'react';

// TODO I am pretty sure ActivityTeacherNote is deprecated. If memory serves
// this was our prototyping document so the content team could being writing
// content while we were still designing the real documet. That real
// document is EngageActivityNote

function ActivityTeacherNote({ children }: {| children: React$Node |}) {
  return (
    <div
      style={{
        marginTop: 100,
        width: 716,
        margin: '0 auto',
        fontFamily: 'Proxima Nova',
        color: '#21374D',
        lineHeight: 1.3,
      }}
    >
      {children}
    </div>
  );
}

function ATNActivityName({ children }: {| children: React$Node |}) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <h1 style={{ fontSize: 20, fontWeight: 600 }}>{children}</h1>
      <div
        style={{
          padding: '10px 15px',
          background: '#0875BE',
          borderRadius: 4,
          color: 'white',
          fontWeight: 600,
        }}
      >
        View task
      </div>
    </div>
  );
}

function ATNOverview({ children }: {| children: React$Node |}) {
  return (
    <>
      <div>{children}</div>
      <div style={{ height: 150 }} />
    </>
  );
}

function ATNCalloutBox({ children }: {| children: React$Node |}) {
  return (
    <div
      style={{
        background: '#F3F9FF',
        borderRadius: 4,
        padding: 20,
      }}
    >
      {children}
    </div>
  );
}

function ATNHeading({
  variant,
  children,
}: {|
  variant: 'medium' | 'large',
  children: React$Node,
|}) {
  const shared = { margin: '16px 0 0 0', fontWeight: 600 };
  if (variant === 'large') {
    return <h2 style={{ ...shared, fontSize: 18 }}>{children}</h2>;
  }
  if (variant === 'medium') {
    return <h3 style={{ ...shared, fontSize: 16 }}>{children}</h3>;
  }
}

function ATNDetails({ children }: {| children: React$Node |}) {
  return <div>{children}</div>;
}

export {
  ActivityTeacherNote,
  ATNActivityName,
  ATNOverview,
  ATNCalloutBox,
  ATNHeading,
  ATNDetails,
};
